import { useEffect, useRef } from 'react'

export function useAutofocus() {
  const autoFocusedElement = useRef()
  useEffect(
    () => {
      if (autoFocusedElement && autoFocusedElement.current) {
        autoFocusedElement.current.focus()
      }
    },
    [autoFocusedElement]
  )
  return autoFocusedElement
}
